import {Mutations} from '@/store/mutations';
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import app from './modules/app';
import permission from './modules/permission';
import settings from './modules/settings';
import tagsView from './modules/tagsView';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    tagsView,
    permission,
    settings
  },
  getters,
  mutations: {
    [Mutations.WEBSOCKET_STATE]: (state: any, status) => {
      state.app.websocketStatus = status;
    }
  }
});

export default store;
